import { FieldMetaProps, FormikHandlers } from 'formik';

// eslint-disable-next-line
export const getFieldValue = (handlers: FormikHandlers, fieldName: string): string => {
    const meta: FieldMetaProps<any> = handlers.getFieldMeta(fieldName);
    return meta.value;
};
